import {
  Button,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { useState } from "react";

const GlobalAudienceFloorsDropdownForm = ({
  submitMethod,
  clearTable,
  editPricingVariables,
  setClear,
}) => {
  const [product, setProduct] = useState("");
  const [pacing, setPacing] = useState("");
  const [audience, setAudience] = useState("");
  const [disablePacing, setDisablePacing] = useState(false);
  const [errorDropDown, setErrorDropDown] = useState({});
  const [isClear, setIsClear] = useState(false);

  const handleProductDropdown = (e) => {
    setProduct(e.target.value);
    if (e.target.value === "podcast") {
      setPacing("uniques");
      setDisablePacing(true);
    } else if (e.target.value === "page_view" && product === "podcast") {
      setPacing("");
      setDisablePacing(false);
    }
  };

  const clearSelection = () => {
    setErrorDropDown({});
    setProduct("");
    setPacing("");
    setAudience("");
    setDisablePacing(false);
    clearTable();
    setIsClear(false);
    setClear();
  };

  const handleApply = (e) => {
    setErrorDropDown((prevError) => ({
      ...prevError,
      product: product === "",
      audience: audience === "",
      pacing: pacing === "" && product !== "podcast",
    }));
    if (
      product === "" ||
      audience === "" ||
      (pacing === "" && product !== "podcast")
    ) {
      return;
    }
    submitMethod({
      product_type: product,
      pacing: product !== "podcast" ? pacing : "uniques",
      audience_type: audience,
    });
    setIsClear(true);
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={3}>
        <FormControl margin="normal" size="small" fullWidth>
          <InputLabel>Product*</InputLabel>
          <Select
            value={product}
            onChange={handleProductDropdown}
            label="Product*"
            fullWidth
            style={isClear ? selectStyleAfterApply : selectStyleBeforeApply}
          >
            <MenuItem value="page_view">PageView</MenuItem>
            <MenuItem value="podcast">Podcast</MenuItem>
          </Select>
          {errorDropDown["product"] && (
            <FormHelperText style={{ color: "red" }}>
              Select a Product type
            </FormHelperText>
          )}
        </FormControl>
      </Grid>
      <Grid item xs={3}>
        <FormControl margin="normal" size="small" fullWidth>
          <InputLabel>Pacing*</InputLabel>
          <Select
            value={pacing}
            onChange={(e) => setPacing(e.target.value)}
            label="Pacing*"
            style={isClear ? selectStyleAfterApply : selectStyleBeforeApply}
            disabled={disablePacing}
          >
            <MenuItem value="fulfillment">Fullfilment</MenuItem>
            <MenuItem value="uniques">Uniques</MenuItem>
          </Select>
          {errorDropDown["pacing"] && (
            <FormHelperText style={{ color: "red" }}>
              Select a Pacing type
            </FormHelperText>
          )}
        </FormControl>
      </Grid>
      <Grid item xs={3}>
        <FormControl margin="normal" size="small" fullWidth>
          <InputLabel sx={{ alignItems: "center" }}>Audience*</InputLabel>
          <Select
            value={audience}
            label="Audience*"
            onChange={(e) => setAudience(e.target.value)}
            style={isClear ? selectStyleAfterApply : selectStyleBeforeApply}
            inputProps={{
              style: inputStyle,
            }}
          >
            <MenuItem value="pharma">Pharma</MenuItem>
            <MenuItem value="non_pharma">Non-pharma</MenuItem>
          </Select>
          {errorDropDown["audience"] && (
            <FormHelperText style={{ color: "red" }}>
              Select a Audience type
            </FormHelperText>
          )}
        </FormControl>
      </Grid>
      <Grid item xs={3}>
        {!editPricingVariables && (
          <Button
            variant="contained"
            color="primary"
            onClick={isClear ? clearSelection : handleApply}
            sx={{ mt: 2 }}
            style={{ width: 76, height: 36 }}
          >
            {isClear ? "Clear" : "Apply"}
          </Button>
        )}
      </Grid>
    </Grid>
  );
};

const selectStyleAfterApply = {
  maxWidth: 220,
  height: 40,
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: 3,
  "& .MuiOutlinedInputRoot": {
    "& fieldset": {
      borderColor: "blue",
    },
    "&:hover fieldset": {
      borderColor: "blue",
    },
    "&.Mui-focused fieldset": {
      borderColor: "blue",
    },
  },
  "& .MuiSvgIcon-root": {
    color: "blue",
  },
};

const selectStyleBeforeApply = {
  maxWidth: 220,
  height: 40,
  gap: 3,
};

const inputStyle = {
  display: "flex",
  alignItems: "center",
  height: "100%",
};

export default GlobalAudienceFloorsDropdownForm;
